<template>
    <section class="">
        <div class="flex-row section-container">
            <div class="community flex-column flex-1">
                <h2 class="section-title">Unsubscribe from Newsletter</h2>
                <p>Hermertia Wars would love to keep sending you updates, but this is your choice! Fill out the form below if you would like to unsubscribe.</p>
                <div class="community flex-left">
                    <simple-input
                        :inputs="inputs"
                        :checkValidity="validateInputs"
                        :checkSelector="'.fieldGroupContainer'"
                        @valid="passFailInputs">
                    </simple-input>
                </div>
                <div class="community flex-row flex-left">
                    <button class="btn btn-primary save-btn" @click.prevent="checkInputs()">
                        Unsubscribe
                    </button>
                    <div class="form-group margin-bottom-0 width-100">
                        <div v-show="this.transactionFeedback['message'] != ''" 
                            class="alert margin-bottom-0"
                            :class="alertLevel" 
                            role="alert">
                                {{this.transactionFeedback['message']}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import generalServices from '../services/GeneralServices';
import SimpleInput from '../components/SimpleInput.vue';
import inputValidationParent from '../utilities/inputValidationParent';

export default {
    name: 'ActivateUser',
    components: {
        SimpleInput
    },
    mixins: [inputValidationParent],
    data() {
        return {
            email: null,
            status: null,
            transactionFeedback: {
                'message': "",
                'code': ""
            },
            inputs: [
                {type: "email", category: "email", required: true},
            ],
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
        async postModal(formInfo){
            try {
                let response = await generalServices.POST_DATA("notifications/deactivate/", formInfo);
                this.transactionFeedback['message'] = response.data;
                this.transactionFeedback['code'] = response.status;
            } catch (err) {
                this.transactionFeedback['message'] = err.response.data;
                this.transactionFeedback['code'] = err.response.status;
            }
        },
    }
};
</script>
<style lang="scss">
</style>
